export default {
  title: `Trend Micro Account`,
  titleIDP: `Trend Micro ID Protection`,
  titleTMC: `Trend Micro ScamCheck`,
  description: `Sign into your Trend Micro account to manage your consumer software subscriptions.`,

  brandedTitle: `Trend Micro`,
  brandedHeadline: `Account`,
  helpCenter: `Help Center`,
  contactSupport: `Contact Support`,
  legalPoliciesPrivacy: `Legal Policies & Privacy`,
  contactUs: `Contact Us`,
  copyright: `Copyright © {year} Trend Micro Incorporated. All rights reserved.`,
  copyrightStatement: `Copyright © {year} Trend Micro Incorporated.`,
  allRightReserved: `All rights reserved.`,
  auth: {
    continueWithEmail: `Continue with Email`,
  },
  error_msg: {
    common: `Oops. Something went wrong.`,
    tryLater: `Please try again later.`,
    errorCode: 'Error code: {error_code}',
  },
  pageUnavaliableTitle: 'This page isn’t available at the moment',
  pageUnavaliableContent:
    'Something went wrong. The team have been informed, and we will check and fix it soon.',
  pageUnavaliableContent1: 'We’re unable to process your request.',
  sorryForInconvenience: 'We’re sorry for any inconvenience.',
  contactSupport1:
    'If you get the same error message again, {contact_support} and provide the error code listed below.',
  contactSupportText: 'contact Support',
  vbUpgrade: {
    title: 'Level up your protection, gain immediate benefits',
    subtitle: 'Upgrade to %SSS_Name%',
    feature_1: 'Protect your devices (up to 6)',
    feature_2: 'Protect your identity',
    feature_3: 'Securely manage your passwords',
    feature_4: 'Securely use free Wi-Fi (VPN)',
    feature_5: 'Get digital life support',
  },
  oot: {
    title: 'Start your free 30-day trial',
    subtitle: 'Product Activation',
    feature_1: 'Protect your devices (up to 6)',
    feature_2: 'Protect your identity',
    feature_3: 'Securely manage your passwords',
    feature_4: 'Securely use free Wi-Fi (VPN)',
  },
  countryRegions: {
    '092': 'Virgin Islands, British',
    100: 'Bulgaria',
    104: 'Burma (Myanmar)',
    108: 'Burundi',
    112: 'Belarus',
    116: 'Cambodia',
    12: 'Algeria',
    120: 'Cameroon',
    124: 'Canada',
    132: 'Cape Verde',
    136: 'Cayman Islands',
    140: 'Central African Republic',
    144: 'Sri Lanka',
    148: 'Chad',
    152: 'Chile',
    156: 'China',
    158: 'Taiwan',
    16: 'American Samoa',
    162: 'Christmas Island',
    166: 'Cocos (Keeling) Islands',
    170: 'Colombia',
    174: 'Comoros',
    175: 'Mayotte',
    178: 'Congo, Republic of',
    180: 'Congo, Democratic Republic of',
    184: 'Cook Islands',
    188: 'Costa Rica',
    191: 'Croatia',
    196: 'Cyprus',
    20: 'Andorra',
    203: 'Czech Republic',
    204: 'Benin',
    208: 'Denmark',
    212: 'Dominica',
    214: 'Dominican Republic',
    218: 'Ecuador',
    222: 'El Salvador',
    226: 'Equatorial Guinea',
    231: 'Ethiopia',
    232: 'Eritrea',
    233: 'Estonia',
    234: 'Faroe Islands',
    238: 'Falkland Islands',
    24: 'Angola',
    242: 'Fiji',
    246: 'Finland',
    248: 'Aland',
    250: 'France',
    254: 'French Guiana',
    258: 'French Polynesia',
    262: 'Djibouti',
    266: 'Gabon',
    268: 'Georgia',
    270: 'Gambia',
    276: 'Germany',
    28: 'Antigua and Barbuda',
    288: 'Ghana',
    292: 'Gibraltar',
    296: 'Kiribati',
    300: 'Greece',
    304: 'Greenland',
    308: 'Grenada',
    31: 'Azerbaijan',
    316: 'Guam',
    32: 'Argentina',
    320: 'Guatemala',
    324: 'Guinea',
    328: 'Guyana',
    332: 'Haiti',
    336: 'Vatican City State',
    340: 'Honduras',
    344: 'Hong Kong',
    348: 'Hungary',
    352: 'Iceland',
    356: 'India',
    36: 'Australia',
    360: 'Indonesia',
    368: 'Iraq',
    372: 'Ireland',
    376: 'Israel',
    380: 'Italy',
    384: 'Cote d&apos;Ivoire',
    388: 'Jamaica',
    392: 'Japan',
    398: 'Kazakhstan',
    4: 'Afghanistan',
    40: 'Austria',
    400: 'Jordan',
    404: 'Kenya',
    410: 'Korea, Republic of (South)',
    414: 'Kuwait',
    417: 'Kyrgyzstan',
    418: 'Laos',
    422: 'Lebanon',
    426: 'Lesotho',
    428: 'Latvia',
    430: 'Liberia',
    438: 'Liechtenstein',
    44: 'Bahamas',
    440: 'Lithuania',
    442: 'Luxembourg',
    446: 'Macao',
    450: 'Madagascar',
    454: 'Malawi',
    458: 'Malaysia',
    462: 'Maldives',
    466: 'Mali',
    470: 'Malta',
    478: 'Mauritania',
    48: 'Bahrain',
    480: 'Mauritius',
    484: 'Mexico',
    492: 'Monaco',
    496: 'Mongolia',
    498: 'Moldova',
    50: 'Bangladesh',
    500: 'Montserrat',
    504: 'Morocco',
    508: 'Mozambique',
    51: 'Armenia',
    512: 'Oman',
    516: 'Namibia',
    52: 'Barbados',
    520: 'Nauru',
    524: 'Nepal',
    528: 'Netherlands',
    530: 'Netherlands Antilles',
    533: 'Aruba',
    540: 'New Caledonia',
    548: 'Vanuatu',
    554: 'New Zealand',
    558: 'Nicaragua',
    56: 'Belgium',
    562: 'Niger',
    566: 'Nigeria',
    570: 'Niue',
    574: 'Norfolk Island',
    578: 'Norway',
    580: 'N. Mariana Islands',
    583: 'Micronesia, Federated States of',
    584: 'Marshall Islands',
    585: 'Palau',
    586: 'Pakistan',
    591: 'Panama',
    598: 'Papua New Guinea',
    60: 'Bermuda',
    600: 'Paraguay',
    604: 'Peru',
    608: 'Philippines',
    612: 'Pitcairn',
    616: 'Poland',
    620: 'Portugal',
    624: 'Guinea-Bissau',
    626: 'East Timor',
    630: 'Puerto Rico',
    634: 'Qatar',
    638: 'Reunion',
    64: 'Bhutan',
    642: 'Romania',
    643: 'Russia Federation',
    646: 'Rwanda',
    654: 'Saint Helena',
    659: 'Saint Kitts and Nevis',
    660: 'Anguilla',
    662: 'Saint Lucia',
    666: 'Saint Pierre and Miquelon',
    670: 'Saint Vincent and the Grenadines',
    674: 'San Marino',
    678: 'Sao Tome and Principe',
    68: 'Bolivia',
    682: 'Saudi Arabia',
    686: 'Senegal',
    690: 'Seychelles',
    694: 'Sierra Leone',
    70: 'Bosnia and Herzegovina',
    702: 'Singapore',
    703: 'Slovakia',
    704: 'Vietnam',
    705: 'Slovenia',
    706: 'Somalia',
    710: 'South Africa',
    716: 'Zimbabwe',
    72: 'Botswana',
    724: 'Spain',
    732: 'Western Sahara',
    740: 'Suriname',
    744: 'Svalbard',
    748: 'Swaziland',
    752: 'Sweden',
    756: 'Switzerland',
    76: 'Brazil',
    762: 'Tajikistan',
    764: 'Thailand',
    768: 'Togo',
    772: 'Tokelau',
    776: 'Tonga',
    780: 'Trinidad and Tobago',
    784: 'United Arab Emirates',
    788: 'Tunisia',
    792: 'Turkey',
    795: 'Turkmenistan',
    796: 'Turks and Caicos Islands',
    798: 'Tuvalu',
    8: 'Albania',
    800: 'Uganda',
    804: 'Ukraine',
    807: 'Macedonia',
    818: 'Egypt',
    826: 'United Kingdom',
    831: 'Guernsey',
    832: 'Jersey',
    833: 'Isle of Man',
    834: 'Tanzania',
    84: 'Belize',
    840: 'United States',
    850: 'Virgin Islands, US',
    854: 'Burkina Faso',
    858: 'Uruguay',
    860: 'Uzbekistan',
    862: 'Venezuela',
    876: 'Wallis and Futuna',
    882: 'Samoa',
    887: 'Yemen',
    891: 'Serbia',
    894: 'Zambia',
    90: 'Solomon Islands',
    96: 'Brunei',
    9891: 'Montenegro',
  },
  nameDisplay: `{firstName} {lastName}`,
};
